<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/close/black</title>
    <g id="atoms/icons/30x30/close/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M7.32309704,6.16116524 L14.7469903,13.585272 L22.1723394,6.16116524 C22.5628637,5.77064094 23.1960287,5.77064094 23.586553,6.16116524 C23.9770773,6.55168953 23.9770773,7.18485451 23.586553,7.5753788 L16.1619903,14.999272 L23.586553,22.4246212 C23.9770773,22.8151455 23.9770773,23.4483105 23.586553,23.8388348 C23.1960287,24.2293591 22.5628637,24.2293591 22.1723394,23.8388348 L14.7469903,16.414272 L7.32309704,23.8388348 C6.93257275,24.2293591 6.29940777,24.2293591 5.90888348,23.8388348 C5.51835918,23.4483105 5.51835918,22.8151455 5.90888348,22.4246212 L13.3329903,14.999272 L5.90888348,7.5753788 C5.51835918,7.18485451 5.51835918,6.55168953 5.90888348,6.16116524 C6.29940777,5.77064094 6.93257275,5.77064094 7.32309704,6.16116524 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
